import CheckCircleOutlineOutlined from '@mui/icons-material/CheckCircleOutlineOutlined'
import { Chip } from '@mui/material'
import { FC } from 'react'
import { AddressValidationResult } from '../../../api/models'
import { SelectedAddressValidationResultIndex } from '../../../atoms' // Adjust the import path as needed

interface ValidationStatusChipProps {
  addressValidationResult?: AddressValidationResult
  selectedAddressValidationResultIndex?: SelectedAddressValidationResultIndex
}

const getValidationStatus = (
  addressValidationResult: AddressValidationResult,
  selectedAddressValidationResultIndex: SelectedAddressValidationResultIndex
) => {
  const hasIssues =
    selectedAddressValidationResultIndex === 'UNVERIFIED' ||
    addressValidationResult?.candidates[selectedAddressValidationResultIndex]?.issues?.length > 0

  return {
    label: hasIssues ? 'Confirmed with warnings' : 'No issues',
    color: hasIssues
      ? {
          bgcolor: 'var(--bg-surface-warning)',
          color: 'var(--text-primary)'
        }
      : {
          bgcolor: 'var(--bg-surface-confirm)',
          color: 'var(--text-primary)'
        },
    icon: <CheckCircleOutlineOutlined fontSize="small" color="primary" />
  }
}

export const ValidationStatusChip: FC<ValidationStatusChipProps> = ({ addressValidationResult, selectedAddressValidationResultIndex }) => {
  if (addressValidationResult && selectedAddressValidationResultIndex !== undefined) {
    const validationStatus = getValidationStatus(addressValidationResult, selectedAddressValidationResultIndex)

    return (
      <Chip
        icon={validationStatus.icon}
        label={validationStatus.label}
        data-testid="validation-status-pill"
        sx={{
          ...validationStatus.color,
          textTransform: 'capitalize',
          fontWeight: 500
        }}
      />
    )
  }
}
